module.exports = __webpack_public_path__ + "img/099df748ea18ae4efa7c0d304b257555.png";